<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="addColumns"
      ref='imgTable'
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';

export default {
  components: {
    pageTemplate
  },
  data() {
    return {
      jumpData: "",
      dialogVisibility: false,
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: '类型',
            type: 'select',
            prop: 'type',
            data: this.$utils.getCacheStatus('mallStoreShuffling.type'),
          },
        ]
      },

      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
        },
        {
          label: '删除',
          type: this.$utils.buttonType.tableOperate,
          code: 'delete'
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '轮播图',
            prop: 'imgUrl',
            width: '120',
            align: 'center',
            type: 'image'
          },
          {label: '创建时间', prop: 'createDttm', width: '190', align: 'center'},
          {
            label: '跳转说明',
            prop: 'typeDesc',
            width: '130',
            align: 'center',
          },
          {
            label: '状态',
            prop: 'openImgStatus',
            type: 'switch',
            width: '120',
            align: 'center',
            change: this.openImgStatusChange,
          },
          {
            label: '是否可用',
            prop: 'status',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus("mallStoreShuffling.status")
          },
        ],
        url: api.mall.mallImg,
      },
      // 添加字段
      addColumns: {
        labelWidth: '350px',
        span: 24,
        columns: [
          {label: '基础信息', type: 'title', span: 24},
          {
            label: '门店照片',
            type: 'image',
            prop: 'imgUrl',
            limit: 10,
            align: "center",
            callback: this.setImageData,
            rule: [{required: true, message: "请上传门店照片！"}]
          },
          {
            label: "状态",
            prop: "status",
            type: "radio",
            align: "center",
            data: this.$utils.getCacheStatus('mallStoreShuffling.status'),
            defaultValue: 10
          },
          {
            label: '跳转类型',
            type: 'select',
            prop: 'type',
            data: this.$utils.getCacheStatus('mallStoreShuffling.type'),
            align: "center",
            change: this.jumyType
          },
          {
            label: '选择分类',
            type: 'select',
            prop: 'goodsCategoryId',
            data: [],
            align: "center",
            url: api.archives.categoryList,
            isShow: false,
            change: this.goodsCategory
          },
          {
            label: '选择功能',
            type: 'select',
            prop: 'functionType',
            data: this.$utils.getCacheStatus('mallNavigationCategory.functionType'),
            align: "center",
            isShow: false,
            change: this.functionChoose
          },
          {
            label: '关联商品',
            type: 'select',
            prop: 'goodsId',
            data: [],
            align: "center",
            url: api.archives.goodsInfo,
            param: {merchantId: this.$utils.getSysUser().merchantId, storeId: this.$utils.getSysUser().storeId},
            isShow: false,
            change: this.goodsChange,
          },
        ],
        url: api.mall.mallImg
      },
      //编辑字段
      editColumns: {
        labelWidth: '350px',
        span: 24,
        columns: [
          {label: '基础信息', type: 'title', span: 24},
          {
            label: '门店照片',
            type: 'image',
            prop: 'imgUrl',
            limit: 10,
            align: "center",
            callback: this.setImageData,
            rule: [{required: true, message: "请上传门店照片！"}]
          },
          {
            label: "状态",
            prop: "status",
            type: "radio",
            align: "center",
            data: this.$utils.getCacheStatus('mallStoreShuffling.status'),
            defaultValue: 10
          },
          {
            label: '跳转类型',
            type: 'select',
            prop: 'type',
            data: this.$utils.getCacheStatus('mallStoreShuffling.type'),
            align: "center",
            change: this.jumyType
          },
          {
            label: '选择分类',
            type: 'select',
            prop: 'goodsCategoryId',
            data: [],
            align: "center",
            url: api.archives.categoryList,
            isShow: false,
            change: this.goodsCategory
          },
          {
            label: '选择功能',
            type: 'select',
            prop: 'functionType',
            data: this.$utils.getCacheStatus('mallNavigationCategory.functionType'),
            align: "center",
            isShow: false,
            change: this.functionChoose
          },
          {
            label: '关联商品',
            type: 'select',
            prop: 'goodsId',
            data: [],
            align: "center",
            url: api.archives.goodsInfo,
            param: {merchantId: this.$utils.getSysUser().merchantId, storeId: this.$utils.getSysUser().storeId},
            isShow: false,
            change: this.goodsChange,
          },
        ],
        url: api.mall.mallImg
      },

    };
  },
  created() {
  }
  ,
  methods: {
    setImageData(formModel, fileList) {
      formModel.imgUrl = fileList[0].response;
    },
    jumyType(data) {
      //console.log(data)
      let goodsCategoryId = this.addColumns.columns.filter(item => item.prop == "goodsCategoryId")[0]
      let goodsFunction = this.addColumns.columns.filter(item => item.prop == 'functionType')[0]
      let goodsId = this.addColumns.columns.filter(item => item.prop == 'goodsId')[0];
      if (data.type === "10") {
        this.jumpData = "商品分类"
        goodsCategoryId.isShow = true;
        goodsFunction.isShow = false;
        goodsId.isShow = false;
      } else if (data.type === "20") {
        this.jumpData = "功能入口";
        goodsCategoryId.isShow = false;
        goodsFunction.isShow = true;
        goodsId.isShow = false;
        goodsId = '';
      } else {
        goodsCategoryId.isShow = false;
        goodsFunction.isShow = false;
        goodsId.isShow = false;
        goodsId = '';
      }
    },
    goodsCategory(data) {
      this.$refs["imgTable"].$refs["formTemplate"].formModel.typeDesc = `${this.jumpData}:${this.$refs["imgTable"].$refs["formTemplate"].formModel.goodsCategoryName}`;
    },
    functionChoose(data) {
      // console.log(data)
      let goodsId = this.addColumns.columns.filter(item => item.prop == 'goodsId')[0];
      let functionTypeArr = this.$utils.getCacheStatus('mallNavigationCategory.functionType');
      if (data.functionType === 20) {
        goodsId.isShow = true;
      } else {
        goodsId.isShow = false;
        goodsId = '';
      }
      functionTypeArr.forEach(element => {
        if (element.value === data.functionType) {
          this.$refs["imgTable"].$refs["formTemplate"].formModel.typeDesc = `${this.jumpData}:${element.label}`
        }
      });
    },
    goodsChange(data) {
      this.$refs["imgTable"].$refs["formTemplate"].formModel.typeDesc = `${this.jumpData}:${data.goodsName}`
    },
    openImgStatusChange(row) {
      this.$axios.fetchPut(api.mall.mallImg, row).then(data => {
        if (data.code === 200) {
          this.loading = false;
          this.$notify({
            type: "success",
            title: '修改操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '修改成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '修改操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '修改失败', type: 'error'});
        }
      }).catch((err) => {
        this.loading = false;
        this.$notify({
          type: "error",
          title: '修改操作',
          message: '失败',
          showClose: false,
        });
        // this.$message({message: '修改失败', type: 'error'});
      });
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/mall/setting/Img.vue